module.exports = __webpack_public_path__ + "img/result_icon_01.efa23d94.jpg";